import getDisplayDialog from '../selectors/getDisplayDialog';

/*
 This util function takes addinInstance to find any active dialog
*/

export default function isAnyDialogOpen(addinIdentifier: string): boolean {
    const dialog = getDisplayDialog(addinIdentifier);
    return !!dialog;
}
